// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"170":"css/app","561":"css/fonts","589":"css/standard-offer"}[chunkId] + ".css";
};